<template>
  <div data-test-id="SettingsPage" class="ems-page">
    <NavBar>
      <template #left>
        <div class="text-red" data-test-id="closeSettingsButton" role="button" tabindex="0" @click="onBackClick">
          Close
        </div>
      </template>
      <template #center>
        <span>
          <b>Settings</b>
        </span>
      </template>
      <template #right>
        <Logout />
      </template>
    </NavBar>
    <b-container>
      <br />
      <b-row class="white-background">
        <b-col data-test-id="changePasswordButton" role="button" tabindex="0" @click="onChangePasswordClick">
          <div class="settings-item">Change Password</div>
        </b-col>
      </b-row>
      <b-row class="white-background">
        <b-col role="button" tabindex="0" @click="onAutoLogoutClick">
          <div class="settings-item">Auto-logout</div>
        </b-col>
      </b-row>
      <b-row v-if="supportsCaseFeedback" class="white-background">
        <b-col role="button" tabindex="0" @click="onCaseFeedbackClick">
          <div class="settings-item">Case Feedback</div>
        </b-col>
      </b-row>
      <b-row v-if="isElectron" class="white-background">
        <b-col role="button" tabindex="0" @click="onGpsClick">
          <div class="settings-item">GPS Data Source</div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import NavBar from "@/App/components/NavBar.vue";
import Logout from "@/App/components/Logout.vue";
import { teamSupportsCaseFeedback } from "@/CaseFeedback/store/featureResolver";

export default {
  name: "Settings",
  components: { NavBar, Logout },
  computed: {
    ...mapGetters("Global", ["isElectron"]),
    supportsCaseFeedback() {
      const selectedAgency = this.$store.getters["TeamSelection/selectedTeam"];
      if (selectedAgency) {
        return teamSupportsCaseFeedback(selectedAgency);
      }
      return false;
    },
  },
  methods: {
    onBackClick() {
      this.$router.push({ name: "start" });
    },
    onTeamClick() {
      this.$router.push({ name: "team-selection" });
    },
    onTruckClick() {
      this.$router.push({ name: "truck-selection" });
    },
    onAutoLogoutClick() {
      this.$router.push({ name: "shift" });
    },
    onChangePasswordClick() {
      this.$router.push({ name: "changePassword" });
    },
    onGpsClick() {
      this.$router.push({ name: "gpsSource" });
    },
    onCaseFeedbackClick() {
      this.$router.push({ name: "caseFeedbackSettings" });
    },
  },
};
</script>

<style scoped>
.white-background {
  background-color: white;
  color: black;
  border-bottom: 1px solid grey;
}
.settings-item {
  margin-top: 5px;
  margin-bottom: 5px;
}
</style>
